module.exports = __webpack_public_path__ + "img/step_import.ec32bba2.svg";